import { Box, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Chart from "react-apexcharts";
import { useNavigate } from "react-router-dom";
import { appLogger } from "../../utils";
import { IFilter } from "../../model";
import { ApexOptions } from "apexcharts";
import { chartHighlighter } from "../../utils/common/chartHighlighter";

interface chartData {
  total: number;
  avg: number;
  data: object;
}
interface ratingChartProps {
  ratingChartData: chartData;
  setChartData: (data: any) => void;
  chartShow: boolean;
  filter?: {
    advanceFilters?: IFilter[];
    filters: IFilter[];
    name?: string;
    id?: string;
  };
  selected?: {
    advanceFilters?: IFilter[];
    filters: IFilter[];
    name?: string;
    id?: string;
  };
}

const RatingChart = (props: ratingChartProps) => {
  const boxRef = useRef<HTMLElement>(null);
  const navigate = useNavigate();
  const { ratingChartData, chartShow, filter, selected, setChartData } = props;
  const categoriesValue = Object.keys(ratingChartData.data);
  const chartData: number[] = Object.values(ratingChartData.data);

  appLogger.info({
    infoObj: {
      method: "RatingChart",
      component: "feedback",
      fileName: "rating.tsx",
      props: props,
    },
  });
  appLogger.info({
    infoObj: {
      method: "RatingChart",
      component: "feedback",
      fileName: "rating.tsx",
      chartData: chartData,
    },
  });

  const filterRating =
    filter && filter?.filters?.filter((n: any) => n.field === "RATINGS");

  useEffect(() => {
    if (filter?.filters) {
    }
  }, [ratingChartData]);

  const options: ApexOptions = {
    xaxis: {
      title: {
        text: "(Counts)",
        offsetY: 4,
        style: {
          fontSize: "10px",
          fontWeight: "400",
          fontFamily: "Poppins",
        },
      },
      categories: [...categoriesValue].reverse(),
      labels: {
        show: true,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    tooltip: {
      custom: function (config: any) {
        return (
          // eslint-disable-next-line @typescript-eslint/tslint/config
          `<div class="custom-tooltip" style="background: ${
            config.w.config.colors[config.dataPointIndex]
          }">` +
          "<h2 class='tooltip-title'>rating :" +
          "<span>" +
          config.w.globals.labels[config.dataPointIndex] +
          "</span>" +
          "</h2>" +
          "<div class='tooltip-info'>" +
          config.w.globals.series[0][config.dataPointIndex] +
          "<span>" +
          `(${
            config.w.globals.series[0][config.dataPointIndex] > 0
              ? Math.floor(
                  (config.w.globals.series[0][config.dataPointIndex] /
                    config.w.globals.seriesTotals[0]) *
                    100
                )
              : 0
          }%)` +
          "</span></div>" +
          "</div>"
        );
      },
    },
    yaxis: {
      show: true,
      title: {
        text: "(Rating)",
        offsetX: 4,
        style: {
          fontSize: "10px",
          fontWeight: "400",
          fontFamily: "Poppins",
        },
      },
    },
    fill: {
      // colors: ["#6FDF8E"],
    },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
        dataLabels: {
          position: "center",
        },
        barHeight: "70%",
      },
    },
    colors: ["#038229", "#76d43b", "#f5c61b", "#fa7c28", "#e61919"],
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    grid: {
      show: false,
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    chart: {
      // events: {
      //   dataPointSelection: function (
      //     event: unknown,
      //     chartContext: unknown,
      //     config: any
      //   ) {
      //     const selectedDataPoints: number[] = config.selectedDataPoints[0];

      //     chartHighlighter(selectedDataPoints, boxRef.current, "bar");

      //     const modifiedArr = selectedDataPoints.map((e) => {
      //       if (e === 0) {
      //         e = 5;
      //       } else if (e === 1) {
      //         e = 4;
      //       } else if (e === 2) {
      //         e = 3;
      //       } else if (e === 3) {
      //         e = 2;
      //       } else if (e === 4) {
      //         e = 1;
      //       }
      //       return e;
      //     });

      //     appLogger.info({
      //       infoObj: {
      //         method: "dataPointSelection",
      //         component: "feedback",
      //         fileName: "rating.tsx",
      //         config: config,
      //       },
      //     });

      //     const dataPointIndexValue = config.dataPointIndex;
      //     const selectedFilterLabel =
      //       config.w.globals.labels[dataPointIndexValue];
      //     const selectedFilterValue =
      //       config.w.config.series[0].data[dataPointIndexValue];
      //     appLogger.info({
      //       infoObj: {
      //         method: "dataPointSelection",
      //         component: "feedback",
      //         fileName: "rating.tsx",
      //         filterData: { selectedFilterLabel, selectedFilterValue },
      //       },
      //     });

      //     const test = {
      //       field: "RATINGS",
      //       operation: "contains",
      //       value: modifiedArr,
      //     };

      //     navigate("/feedback", {
      //       state: {
      //         ratingsClicked: test,
      //       },
      //     });
      //     setChartData(test);
      //   },
      //   updated: function (config: any) {
      //     if (filter && filter.filters) {
      //       const modifiedFilter = (
      //         filter.filters.find((data) => data.field === "RATINGS") as {
      //           value: number[];
      //         }
      //       )?.value.map((e) => {
      //         if (e === 5) {
      //           e = 0;
      //         } else if (e === 4) {
      //           e = 1;
      //         } else if (e === 3) {
      //           e = 2;
      //         } else if (e === 2) {
      //           e = 3;
      //         } else if (e === 1) {
      //           e = 4;
      //         }
      //         return e;
      //       });

      //       chartHighlighter(modifiedFilter, boxRef.current, "bar");

      //       config.w.globals.selectedDataPoints[0] =
      //         filter?.filters?.length === 1 && !selected ? modifiedFilter : [];
      //     }
      //     if (!filter?.filters) {
      //       config.w.globals.selectedDataPoints[0] = [];
      //     }
      //   },
      //   mounted: function (config: any) {
      //     const modifiedFilter = filter?.filters
      //       ?.find((data) => data.field === "RATINGS")
      //       ?.value.map((e: any) => {
      //         if (e === 5) {
      //           e = 0;
      //         } else if (e === 4) {
      //           e = 1;
      //         } else if (e === 3) {
      //           e = 2;
      //         } else if (e === 2) {
      //           e = 3;
      //         } else if (e === 1) {
      //           e = 4;
      //         }
      //         return e;
      //       });

      //     chartHighlighter(modifiedFilter, boxRef.current, "bar");

      //     config.w.globals.selectedDataPoints[0] =
      //       filter?.filters?.length === 1 && !selected ? modifiedFilter : [];

      //     if (!filter?.filters) {
      //       config.w.globals.selectedDataPoints[0] = [];
      //     }
      //   },
      // },
      toolbar: {
        tools: {
          download: true,
        },
        export: {
          csv: {
            filename: "CuVo_Feedbacks",
          },
          svg: {
            filename: "CuVo_Feedbacks",
          },
          png: {
            filename: "CuVo_Feedbacks",
          },
        },
      },
    },
    states: {
      active: {
        allowMultipleDataPointsSelection: false,
      },
    },
  };

  const series = [
    {
      name: "Ratings",
      data: chartData.reverse(),
    },
  ];

  return (
    <>
      {chartShow && (
        <>
          {ratingChartData.total > 0 ? (
            <Box
              ref={boxRef}
              className="rating-chart-wrap"
              sx={{ display: "flex" }}
            >
              <Chart
                options={options}
                series={series}
                height={230}
                type="bar"
              />
            </Box>
          ) : (
            <Typography className="no-data">no data</Typography>
          )}
        </>
      )}
    </>
  );
};

export default RatingChart;
